// ---------------------------------------------------------------------------
// banners-cards — registry for the banners page's card strip (consumer #2)
// ---------------------------------------------------------------------------
//
// The cardsSection seam on createCrudPage calls this to build the descriptors.
// Adding a banners card later = add one factory call here.
//
// PAGE-LAYER CLASSIFICATION: stays in pages/ despite two consumers
// (banners.js, banners-grid.js) — they are variants of the same banners page,
// and these are page-domain card descriptors, not a multi-module composition;
// the features/ tier is for the latter.

import { createBannersOverviewCard } from './banners-overview-card.js';
import { createBannersByTypeCard } from './banners-by-type-card.js';

/**
 * @typedef {import('../factories/crud-page.js').CardsSectionContext} Ctx
 * @typedef {import('../../contracts/card-grid.js').CardDescriptor & { render: (ctx: Ctx) => import('../../contracts/card-grid.js').CardHandle }} BannersCard
 */

/**
 * @param {Ctx} _ctx
 * @returns {BannersCard[]}
 */
export function bannersCards(_ctx) {
  return [
    sized(createBannersOverviewCard(), 2, 1),
    sized(createBannersByTypeCard(), 2, 2),
  ];
}

/**
 * @param {BannersCard} card @param {1|2|3|4} colSpan @param {1|2} rowSpan @returns {BannersCard}
 */
function sized(card, colSpan, rowSpan) {
  return { ...card, colSpan, rowSpan };
}
